/** Link preview frame chrome. */
export default {
  noPreview: "No preview available",
  openLink: "Open link",
  copyLink: "Copy link",
} as const;
